"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeContentRulesIntoResults = exports.transformConstructorContentRule = exports.parseContentRuleIndexes = exports.transformConstructorSearchResults = void 0;
const helpers_1 = require("../../helpers");
const helpers_2 = require("../../../helpers");
const transformConstructorSearchResults = ({ searchRequest, searchResults, destinationZone, }) => {
    const { num_results_per_page: hitsPerPage = 100, page = 1 } = searchRequest || {};
    return searchResults.map(({ data, value, labels, is_slotted }, index) => {
        const { artist_first_name, artist_last_name, artist_id, artwork_category, country, depth, geo_prices, height, id, image_url, is_ready_to_hang, materials, mediums, orientation, styles, subject, url, width, artist_profile_url, image_aspect_ratio, print_image_aspect_ratio, print_min_price, print_materials, print_dimensions, print_frames, original_availability_status, print_availability_status, sku, created_at, curated_status, } = data;
        return {
            // BaseArtwork fields
            artworkTitle: value,
            artworkId: id,
            artworkOriginalUrl: url,
            artworkSizeBin: '',
            artistFirstName: artist_first_name,
            artistLastName: artist_last_name,
            artistId: artist_id,
            artistProfileUrl: artist_profile_url,
            imageUrl: image_url,
            countryName: country,
            city: '',
            category: (0, helpers_2.capitalizeString)(artwork_category),
            aspectRatio: (0, helpers_1.getAspectRatio)({
                isPrintsPage: Boolean(print_min_price),
                aspectRatio: image_aspect_ratio,
                printAspectRatio: print_image_aspect_ratio,
            }),
            dimensions: {
                widthInCentimeters: width,
                heightInCentimeters: height,
                depthInCentimeters: depth,
            },
            hasPrintsAvailable: Boolean(print_min_price),
            geoPricesInCents: geo_prices,
            minPrintPriceInCents: print_min_price,
            originalArtworkStatus: original_availability_status,
            sku: sku !== null && sku !== void 0 ? sku : '--', // To avoid GTM error
            styles,
            subject,
            materials,
            mediums,
            keywords: [],
            // PolaroidArtwork fields
            listPriceInCents: geo_prices === null || geo_prices === void 0 ? void 0 : geo_prices[destinationZone],
            artworkPrintUrl: url.replace('/art/', '/print/'), // need to format to include '/print'
            hasOpenEditions: Boolean(print_min_price), // needed for data layer events to check if it is original or print
            printAvailabilityStatus: print_availability_status,
            printMaterials: print_materials,
            printDimensions: print_dimensions,
            printFrames: print_frames,
            isReadyToHang: Boolean(is_ready_to_hang),
            orientation,
            positionID: hitsPerPage * (page - 1) + (index + 1),
            artworkUploadedDate: created_at,
            curatedStatus: curated_status,
            isSponsored: Boolean(labels === null || labels === void 0 ? void 0 : labels.is_retail_media),
            isSlotted: Boolean(is_slotted) && !Boolean(labels === null || labels === void 0 ? void 0 : labels.is_retail_media), // isSlotted means we sponsored, not the artist
            slCampaignId: labels === null || labels === void 0 ? void 0 : labels.sl_campaign_id,
            slCampaignOwner: labels === null || labels === void 0 ? void 0 : labels.sl_campaign_owner,
            componentType: 'artwork',
        };
    });
};
exports.transformConstructorSearchResults = transformConstructorSearchResults;
const parseContentRuleIndexes = (index) => {
    if (!(index === null || index === void 0 ? void 0 : index.trim())) {
        return [];
    }
    return index
        .split(',')
        .map((indexNumber) => indexNumber.trim())
        .filter((indexNumber) => indexNumber !== '');
};
exports.parseContentRuleIndexes = parseContentRuleIndexes;
const transformConstructorContentRule = ({ constructorResponse, }) => {
    const contentRules = (constructorResponse === null || constructorResponse === void 0 ? void 0 : constructorResponse.refined_content) || [];
    return contentRules.flatMap(({ data }) => {
        const indexes = (0, exports.parseContentRuleIndexes)(data === null || data === void 0 ? void 0 : data.index);
        if (!indexes.length) {
            return [];
        }
        return indexes.map((index) => ({
            altText: (data === null || data === void 0 ? void 0 : data.altText) || '',
            assetUrl: (data === null || data === void 0 ? void 0 : data.assetUrl) || '',
            body: (data === null || data === void 0 ? void 0 : data.body) || '',
            ctaLink: (data === null || data === void 0 ? void 0 : data.ctaLink) || '',
            ctaText: (data === null || data === void 0 ? void 0 : data.ctaText) || '',
            header: (data === null || data === void 0 ? void 0 : data.header) || '',
            index,
            componentType: 'custom',
        }));
    });
};
exports.transformConstructorContentRule = transformConstructorContentRule;
const mergeContentRulesIntoResults = (results, contentRules) => {
    if (!contentRules.length) {
        return results;
    }
    const positionIDs = results.map((result) => result.positionID);
    if (!positionIDs.length) {
        return results;
    }
    const minPositionID = Math.min(...positionIDs);
    const maxPositionID = Math.max(...positionIDs);
    const rulesInRange = contentRules.filter((rule) => {
        const ruleIndex = Number(rule.index);
        return ruleIndex >= minPositionID && ruleIndex <= maxPositionID;
    });
    if (!rulesInRange.length) {
        return results;
    }
    const merged = [...results];
    const sortedRules = [...rulesInRange].sort((itemA, itemB) => Number(itemA.index) - Number(itemB.index));
    sortedRules.forEach((rule) => {
        // Compute array position relative to this page's starting positionID.
        // Splicing into the current (already-growing) array means each prior
        // insertion has already shifted subsequent slots, so consecutive rules
        // stack together naturally without an extra offset.
        const position = Math.min(Number(rule.index) - minPositionID + 1, merged.length);
        merged.splice(position, 0, rule);
    });
    return merged;
};
exports.mergeContentRulesIntoResults = mergeContentRulesIntoResults;
